/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Success_TitleInputs */



/**
* | output |
* | --- |
* | "Publish Successful" |
*
* @param {Iconik_Publish_Success_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_success_title = /** @type {((inputs?: Iconik_Publish_Success_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Success_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Publication reussie")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erfolgreich veröffentlichen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pubblicazione riuscita")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Опубликовано успешно")
	if (locale === "es") return /** @type {LocalizedString} */ ("Publicación exitosa")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("发布成功")
	if (locale === "ja") return /** @type {LocalizedString} */ ("公開に成功しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सफल प्रकाशन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Publicação bem-sucedida")
	return /** @type {LocalizedString} */ ("Publish Successful")
});